// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3n3co","empty":"ModalGraph_empty__13-2Q"};